import { Grid } from '@mui/material';
import { RoutalDialog, RoutalLoader, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import _ from 'lodash';
import { ApiKey, ApiKeyProps } from '../../../../../domain/apiKey/ApiKey';
import { useUpdateApiKey } from '../../../../../hooks/apiKey/useUpdateApiKey';
import Button from '../../../../../react-components/Button';
import InputText from '../../../../../react-components/InputText';
import Text from '../../../../../react-components/Text';

interface UpdateApiKeyDialogProps {
  apiKey: ApiKey;
  onClose: () => void;
}

export const UpdateApiKeyDialog = ({ apiKey, onClose }: UpdateApiKeyDialogProps) => {
  const { run: updateApiKey, isLoading, success, error } = useUpdateApiKey();

  const [apiKeyData, setApiKeyData] = useState<Partial<ApiKeyProps>>({
    label: apiKey.label,
  });

  useEffect(() => {
    if (success || error) {
      onClose();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, error]);

  const isFormDisabled = () => {
    if (isLoading) return true;

    try {
      return _.isEqual(apiKeyData, {
        label: apiKey.label,
      });
    } catch (e) {
      return true;
    }
  };

  return (
    <RoutalDialog
      open
      onCloseDialog={() => onClose()}
      titleContent={<Text variant="h6" intlId={`settings.developers.api_keys.update.title`} />}
      dialogProps={{
        fullWidth: true,
        maxWidth: `sm`,
      }}
      footerContent={
        <Button
          onClick={() => {
            apiKey.label = apiKeyData.label!;
            updateApiKey({ apiKey });
          }}
          disabled={isFormDisabled()}
          style={{ maxHeight: `1.2rem` }}
        >
          {isLoading ? (
            <RoutalLoader width={12} color={RoutalPalette.neutral00} />
          ) : (
            <Text intlId="settings.developers.api_keys.update.confirm" style={{ color: RoutalPalette.neutral00 }} />
          )}
        </Button>
      }
    >
      <Grid style={{ padding: `16px` }}>
        <Grid item>
          <Text intlId="settings.developers.api_keys.update.name" />
        </Grid>

        <VSpacer small />

        <Grid item container direction="column">
          <Grid item style={{ width: `100%` }}>
            <InputText
              inputContainerStyles={{ width: `100%` }}
              placeholderIntlId="settings.developers.api_keys.update.name_ph"
              fieldValue={apiKeyData.label}
              onChange={(label: string) => {
                setApiKeyData((prevData) => ({ ...prevData, label: label }));
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </RoutalDialog>
  );
};
